<template>
	<div class="text">
		<div class="mb-16 mt-16" v-if="balance > 0">
			{{ $t('morelikesReceived', { count: likesCount }) }}&nbsp;<b>{{ formattedDate }} </b>
		</div>
		<div class="mb-16 mt-16" v-else>
			{{ $t('likesReceived', { count: likesCount }) }}&nbsp;<b>{{ formattedDate }} </b>
		</div>
		{{ $t('subscribeForLikes') }}
	</div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useModalStore } from '@/stores/modal'
import { useProfileStore } from '@/stores/profile'
import { subscriptionsParams } from '@/constants'

export default {
	name: 'NotificationBalance',
	data() {
		return {
			timeUntilTomorrow: null,
			dateOptions: {
				timeZone: 'Europe/Moscow',
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric',
				hour12: false
			}
		}
	},
	computed: {
		...mapState(useModalStore, ['balanceNotification']),
		...mapState(useProfileStore, [
			'total_subscriptions',
			'has_subscription_to_service',
			'subscriptionsData',
			'balance',
			'getLikesCount'
		]),
		formattedDate() {
			return this?.timeUntilTomorrow?.toLocaleString(this.$i18n.locale, this.dateOptions)
		},
		likesCount() {
			return `${this.getLikesCount} ${this.$t('like', this.getLikesCount)}`
		}
	},
	methods: {
		...mapActions(useModalStore, ['closeBalanceNotification']),
		calculateTime() {
			const now = new Date()

			const tomorrow = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)

			this.timeUntilTomorrow = new Date(tomorrow - now + 3600000)
		}
	},
	mounted() {
		this.calculateTime()
		window.setInterval(this.calculateTime, 1000)
	},
	beforeUnmount() {
		window.clearInterval(this.calculateTime)
	}
}
</script>

<style scoped lang="scss">
.text {
	color: $color-gray;
	line-height: 20px;
	margin-bottom: 30px;
}
</style>
